var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{ref:"Logo",attrs:{"id":"titlebar"}},[_c('b-img',{staticClass:"logo",attrs:{"src":require("../assets/flying-freelancers-logo.svg"),"alt":"Flying Freelancers","id":"logo"}}),(_vm.loading)?_c('b-spinner',{attrs:{"small":""}}):_vm._e(),_c('Navigation'),_c('i',{staticClass:"fa-solid fa-user"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }